import { render } from "./drafts-feedbacks.vue?vue&type=template&id=e4013af8&ts=true"
import script from "./drafts-feedbacks.vue?vue&type=script&lang=ts"
export * from "./drafts-feedbacks.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__